/* eslint-disable @direct-frontend/modules/no-restricted-entity-imports -- обёртка над shared IntegrationMappingEditor */
import { type FC } from 'react';
import {
    IntegrationMappingEditor,
    type IntegrationMappingEditorProps,
} from '#shared/components/IntegrationMappingEditor';
import { useIntegrationMappingAvailableItems } from './hooks/useIntegrationMappingAvailableItems';

export type IntegrationMappingEditorWithDataProps = Omit<
    IntegrationMappingEditorProps,
    'availableItems' | 'isFetching' | 'isError' | 'onRetry'
> & {};

export const IntegrationMappingEditorWithData: FC<IntegrationMappingEditorWithDataProps> = ({
    selectedTags,
    ...props
}) => {
    const { availableItems, isFetching, isError, onRetry } = useIntegrationMappingAvailableItems({ selectedTags });

    return (
        <IntegrationMappingEditor
            {...props}
            selectedTags={selectedTags}
            availableItems={availableItems}
            isFetching={isFetching}
            isError={isError}
            onRetry={onRetry}
        />
    );
};
